import { Link } from "react-router-dom";
import { Crown } from "lucide-react";

/**
 * Phase 2J: shared plan-gate card, extracted from what was previously two
 * near-identical copies (Administration.jsx, InAppBookingSettings.jsx).
 * Renders the structured `plan_upgrade_required` 403 body every
 * `*_or_enterprise` backend guard already returns
 * (administration/guards.py, communications/guards.py, analytics/guards.py),
 * with one visual language everywhere a feature is plan-locked.
 */
export default function UpgradeCard({ detail, isOwner, title, features, note }) {
  return (
    <div className="max-w-2xl space-y-4" data-testid="upgrade-card">
      <div className="rounded-2xl border-2 border-dashed border-amber-300 bg-white p-8">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-amber-50 border border-amber-200 text-xs font-semibold text-amber-800">
          <Crown className="w-3.5 h-3.5" /> Pro / Enterprise feature
        </div>
        <h1 className="font-display text-3xl font-bold mt-3">{title || "This feature needs a different plan"}</h1>
        <p className="mt-2 text-slate-600">{detail?.message}</p>
        {note && (
          <div className="mt-4 rounded-lg bg-slate-50 border border-slate-200 p-3 text-sm text-slate-700">
            {note}
          </div>
        )}
        {features && features.length > 0 && (
          <ul className="mt-4 space-y-1.5 text-sm text-slate-700">
            {features.map((f) => <li key={f}>• {f}</li>)}
          </ul>
        )}
        <div className="mt-5 text-xs text-slate-500">
          Your current plan: <strong>{detail?.current_plan}</strong>
        </div>
        {isOwner ? (
          <Link
            to="/app/billing"
            data-testid="upgrade-card-cta"
            className="mt-5 inline-flex items-center gap-2 px-4 py-2.5 rounded-lg btn-brand text-sm font-medium"
          >
            See plans & upgrade
          </Link>
        ) : (
          <div className="mt-5 text-sm text-slate-600">
            Ask your business owner to upgrade the plan to enable this section.
          </div>
        )}
      </div>
    </div>
  );
}
